// extracted by mini-css-extract-plugin
module.exports = {"contact":"styles_contact__1Tbr9","wrap":"styles_wrap__qV-Pb","info_wrap":"styles_info_wrap__2T1zt"};